import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ForgotPassPayload,
  initialStateProps,
  LoginPayload,
  OtpVerifyPayload,
  ResetPassPayload,
} from "./Interface";
import ApiHelperFunction from "../../api";
import { roleId, userId } from "../../utils/StorageUtils";

// Define a type for the payload

/**
 * API calling
 *
 *
 */
export const logIn = createAsyncThunk(
  "auth/login",
  async (payload: LoginPayload, { dispatch, rejectWithValue }) => {
    try {
      const response = await ApiHelperFunction({
        url: "/login/",
        method: "post",
        data: payload,
        dispatch,
      });

      return response?.data;
    } catch (error: any) {
      console.log("Login Error:", error);
  return error?.data?.message || error?.message || "Something went wrong";
      return rejectWithValue(
        error || "Something went wrong"
      );
    }
  }
);

export const logOut = createAsyncThunk(
  "/login/",
  async (payload: any, { dispatch }) => {
    const response = await ApiHelperFunction({
      url: "/logout/", 
      method: "post", 
      // data: payload, // payload data
      dispatch,
      headers: {
        Authorization: payload, // Add token to Authorization header
      },
    });

    let resData = response?.data;
    return resData;
  }
);
export const forgotPassword = createAsyncThunk(
  "/forgot-password/",
  async (payload: ForgotPassPayload, { dispatch }) => {
    const response = await ApiHelperFunction({
      url: "/forgot-password/",
      method: "post",
      data: payload,
      dispatch,
    });

    // Return only the data you need to keep it serializable
    return {
      data: response.data,
    };
  }
);

export const otpVerify = createAsyncThunk(
  "/verify-otp/",
  async (payload: OtpVerifyPayload, { dispatch }) => {
    const response = await ApiHelperFunction({
      url: "/verify-otp/",
      method: "post",
      data: payload,
      dispatch,
    });

    // Return only the data you need to keep it serializable
    return {
      data: response.data,
    };
  }
);

export const resetPassword = createAsyncThunk(
  "/set-password/",
  async (payload: ResetPassPayload, { dispatch }) => {
    const response = await ApiHelperFunction({
      url: "/set-password/",
      method: "post",
      data: payload,
      dispatch,
    });

    // Return only the data you need to keep it serializable
    return {
      data: response.data,
    };
  }
);

/**
 * The initial state of the auth slice.
 */
const storedAuthUserId = userId;
const storedAuthRoleId = roleId;
export const initialState: initialStateProps = {
  status: "idle",
  email: "",
  password: "",
  token: "",
  error: "",
  userData: [],
  userDetail: [],
  otp: 0,
  userId: storedAuthUserId || null,
  roleId: storedAuthUserId || null
};

/**
 * The auth slice.
 */
export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    restAll: (state) => {
      state.error = "";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(logIn.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(logIn.fulfilled, (state, action) => {
        state.status = "succeeded";
      
        state.userData = action.payload?.data?.user || [];
        state.email = action.payload?.data?.email || "";
        state.userId = action.payload?.data?.user_data?.id || null;
        state.roleId = action.payload?.data?.user_data?.role_id || null;
        
      })
      .addCase(logIn.rejected, (state, action) => {
        state.status = "failed";
      });
  },
});

export const { restAll } = authSlice.actions;

export default authSlice.reducer;
